import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { VoutchersService } from '../../../../core/services/vouchers/vouchers.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class VouchersComponentService {
    vouchers: any[];
    onVouchersChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private readonly vouchersService: VoutchersService,
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getVouchers(),
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getVouchers(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.vouchersService.list()
                .subscribe((response) => {
                    this.vouchers = response;
                    this.onVouchersChanged.next(this.vouchers);
                    resolve(response);
                }, reject);
        });
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/vouchers/vouchers.component.service.ts